<ng-container *ngIf="countries$ | async as countries">
  <dcp-country-switch-modal #countrySwitchModalComponent [countries]="countries"></dcp-country-switch-modal>
</ng-container>
<h5 class="ds-body ds-color--black mt-4 mt-lg-0">{{'leadForm.sections.companyDetails' | cxTranslate}}</h5>
<ng-container *ngIf="userType">
  <div data-cy="input">
    <ds-input #companyName
              [(ngModel)]="leadFormModel.addressesMap.LTAC.companyName"
              [disabled]="userType.isEmployeeLogin"
              [label]="'leadForm.fields.companyName' | cxTranslate"
              [placeholder]="'leadForm.fields.companyName' | cxTranslate"
              [showErrorMessages]="submitted"
              class="mt-4"
              dcpWhitespaceOnly
              fieldName="companyName"
              maxlength="255"
              name="companyName"
              required
              type="text">
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(companyName, 'required') || hasValidationFailed(companyName, 'whitespaceOnly')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(companyName, 'maxlength')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.employeeSAPCompany' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(companyName, 'pattern') && !hasValidationFailed(companyName, 'required') && sapEmployeeSubject.value">
    </ds-input-error>
  </div>
  <ng-container *ngIf="shouldShowExternalHarmonyCustomerId()">
    <div data-cy="input">
      <ds-input #customerId
                [(ngModel)]="leadFormContractDataModel.sapCustomerID"
                [disabled]="userType.isEmployeeLogin"
                [label]="'leadForm.fields.customerId' | cxTranslate"
                [placeholder]="'leadForm.fields.customerId' | cxTranslate"
                [showErrorMessages]="submitted"
                class="mt-4"
                dcpWhitespaceOnly
                fieldName="customerId"
                maxlength="255"
                name="customerId"
                required
                type="text">
      </ds-input>
      <ds-input-error
        [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
        [showError]="hasValidationFailed(customerId, 'required') || hasValidationFailed(customerId, 'whitespaceOnly')">
      </ds-input-error>
      <ds-input-error
        [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
        [showError]="hasValidationFailed(customerId, 'maxlength')">
      </ds-input-error>
    </div>
  </ng-container>
  <div data-cy="input">
    <ng-container *ngIf="countries$ | async as countries">
      <ds-country-selector
        #countrySelector
        (ngModelChange)="onCountryChange($event)"
        [(ngModel)]="leadFormModel.addressesMap.LTAC.country.isocode"
        [countryList]="countries"
        [initialCountry]="initialCountry.isocode"
        [searchPlaceholder]="'countrySelector.searchPlaceholder' | cxTranslate"
        class="mt-4"
        label="{{'leadForm.fields.country' | cxTranslate}}"
        name="country"
      >
      </ds-country-selector>
    </ng-container>
  </div>
  <div data-cy="input">
    <ds-input
      #streetAddress
      (focusEvent)="onStreetAddressFocus($event)"
      [(ngModel)]="leadFormModel.addressesMap.LTAC.line1"
      [disabled]="userType.isEmployeeLogin"
      [label]="(sapEmployeeSubject.value ? 'leadForm.fields.street.streetAddressEmployee' : 'leadForm.fields.street.streetAddress') | cxTranslate"
      [placeholder]="(sapEmployeeSubject.value ? 'leadForm.fields.street.streetAddressEmployee' : 'leadForm.fields.street.streetAddress') | cxTranslate"
      [required]="!sapEmployeeSubject.value"
      [showErrorMessages]="submitted"
      [tooltipContent]="'leadForm.fields.street.streetTooltip' | cxTranslate"
      class="mt-4"
      fieldName="streetAddress"
      maxlength="255"
      name="streetAddress"
      type="text">
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(streetAddress, 'required') || hasValidationFailed(streetAddress, 'whitespaceOnly')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(streetAddress, 'maxlength')">
    </ds-input-error>
  </div>
  <div [hidden]="sapEmployeeSubject.value &&  !(streetAddress.hasFocus || streetAddress.innerValue)">
    <div data-cy="input">
      <ds-input
        [(ngModel)]="leadFormModel.addressesMap.LTAC.town"
        [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
        [label]="'leadForm.fields.city' | cxTranslate"
        [placeholder]="'leadForm.fields.city' | cxTranslate"
        [required]="!sapEmployeeSubject.value"
        [showErrorMessages]="submitted"
        class="mt-4"
        fieldName="city"
        name="city"
        type="text">
      </ds-input>
    </div>
    <div class="row">
      <div class="col-6 col-lg-9 col-xl-5 order-xl-2 postal-col">
        <div data-cy="input">
          <ds-input
            [(ngModel)]="leadFormModel.addressesMap.LTAC.postalCode"
            [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
            [label]="'leadForm.fields.postalCode' | cxTranslate"
            [placeholder]="'leadForm.fields.postalCode' | cxTranslate"
            [required]="!sapEmployeeSubject.value"
            [showErrorMessages]="submitted"
            class="mt-4"
            fieldName="postalCode"
            name="postal"
            type="text">
          </ds-input>
        </div>
      </div>
      <ng-container *ngIf="regions$ | async as regions">
        <ng-container *ngIf="regions && regions.length">
          <div class="col-12 col-xl-7 order-xl-1 region-col" data-cy="region">
            <ds-combo-box #regionField
                          (valueChange)="onRegionChange($event)"
                          [(ngModel)]="leadFormModel.addressesMap.LTAC.regionIsocodeArray"
                          [label]="'leadForm.fields.region' | cxTranslate"
                          [multiselect]="false"
                          [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
                          [required]="!sapEmployeeSubject.value"
                          [showErrorMessages]="hasValidationFailed(regionField.formControl, 'required') && submitted"
                          class="mt-4"
                          itemDisabled="userType.isEmployeeLogin"
                          name="region">
              <ds-combo-box-dropdown #singleCombo [initialValue]="['1']" [multiselect]="false">
                <ds-combo-box-dropdown-group maxHeight="12.5rem">
                  <ds-combo-box-dropdown-option
                    *ngFor="let region of regions"
                    [displayCheckbox]="false"
                    [label]="region.name"
                    [value]="region.isocode">
                    <span [innerHTML]="region.name | textSearchHighlight:singleCombo.searchInput"></span>
                  </ds-combo-box-dropdown-option>
                </ds-combo-box-dropdown-group>
              </ds-combo-box-dropdown>
            </ds-combo-box>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
